import React, { useState } from "react";
import { Form, Field } from "react-final-form";
import {
  TextInput,
  TextInputMinimal
} from "../../libraries/nodejs-manager/src/final-form";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

const textColorThemes = {
  ["none"]: "text-gray-700 ",
  ["black"]: "text-black",
  ["white"]: "text-white",
  ["rose"]: "text-rose-900",
  ["pink"]: "text-pink-900",
  ["fuchsia"]: "text-fuchsia-900",
  ["purple"]: "text-purple-900",
  ["violet"]: "text-violet-900",
  ["indigo"]: "text-indigo-900",
  ["blue"]: "text-blue-900",
  ["sky"]: "text-sky-900",
  ["cyan"]: "text-cyan-900",
  ["teal"]: "text-teal-900",
  ["emerald"]: "text-emerald-900",
  ["green"]: "text-green-900",
  ["lime"]: "text-lime-900",
  ["yellow"]: "text-yellow-900",
  ["amber"]: "text-amber-900",
  ["orange"]: "text-orange-900",
  ["red"]: "text-red-900",
  ["stone"]: "text-stone-900",
  ["neutral"]: "text-neutral-900",
  ["gray"]: "text-gray-900",
  ["slate"]: "text-slate-900"
};

const borderColorThemes = {
  ["none"]: "border-gray-300 focus:ring-indigo-100 focus:border-indigo-300",
  ["black"]: "border-black focus:ring-black focus:border-black",
  ["white"]: "border-white focus:ring-white focus:border-white",
  ["rose"]: "border-rose-400 focus:ring-rose-100 focus:border-rose-300",
  ["pink"]: "border-pink-400 focus:ring-pink-100 focus:border-pink-300",
  ["fuchsia"]:
    "border-fuchsia-400 focus:ring-fuchsia-100 focus:border-fuchsia-300",
  ["purple"]: "border-purple-400 focus:ring-purple-100 focus:border-purple-300",
  ["violet"]: "border-violet-400 focus:ring-violet-100 focus:border-violet-300",
  ["indigo"]: "border-indigo-400 focus:ring-indigo-100 focus:border-indigo-300",
  ["blue"]: "border-blue-400 focus:ring-blue-100 focus:border-blue-300",
  ["sky"]: "border-sky-400 focus:ring-sky-100 focus:border-sky-300",
  ["cyan"]: "border-cyan-400 focus:ring-cyan-100 focus:border-cyan-300",
  ["teal"]: "border-teal-400 focus:ring-teal-100 focus:border-teal-300",
  ["emerald"]:
    "border-emerald-400 focus:ring-emerald-100 focus:border-emerald-300",
  ["green"]: "border-green-400 focus:ring-green-100 focus:border-green-300",
  ["lime"]: "border-lime-400 focus:ring-lime-100 focus:border-lime-300",
  ["yellow"]: "border-yellow-400 focus:ring-yellow-100 focus:border-yellow-300",
  ["amber"]: "border-amber-400 focus:ring-amber-100 focus:border-amber-300",
  ["orange"]: "border-orange-400 focus:ring-orange-100 focus:border-orange-300",
  ["red"]: "border-red-400 focus:ring-red-100 focus:border-red-300",
  ["stone"]: "border-stone-400 focus:ring-stone-100 focus:border-stone-300",
  ["neutral"]:
    "border-neutral-400 focus:ring-neutral-100 focus:border-neutral-300",
  ["gray"]: "border-gray-400 focus:ring-gray-100 focus:border-gray-300",
  ["slate"]: "border-slate-400 focus:ring-slate-100 focus:border-slate-300"
};

const buttonColorThemes = {
  ["black"]: "bg-black text-white hover:bg-gray-900",
  ["white"]:
    "bg-white text-black hover:bg-gray-100 focus-visible:outline-white border border-gray-300",
  ["rose"]:
    "bg-rose-700 text-white hover:bg-rose-500 focus-visible:outline-rose-700",
  ["pink"]:
    "bg-pink-700 text-white hover:bg-pink-500 focus-visible:outline-pink-700",
  ["fuchsia"]:
    "bg-fuchsia-700 text-white hover:bg-fuchsia-500 focus-visible:outline-fuchsia-700",
  ["purple"]:
    "bg-purple-700 text-white hover:bg-purple-500 focus-visible:outline-purple-700",
  ["violet"]:
    "bg-violet-700 text-white hover:bg-violet-500 focus-visible:outline-violet-700",
  ["indigo"]:
    "bg-indigo-700 text-white hover:bg-indigo-500 focus-visible:outline-indigo-700",
  ["blue"]:
    "bg-blue-700 text-white hover:bg-blue-500 focus-visible:outline-blue-700",
  ["sky"]:
    "bg-sky-700 text-white hover:bg-sky-500 focus-visible:outline-sky-700",
  ["cyan"]:
    "bg-cyan-700 text-white hover:bg-cyan-500 focus-visible:outline-cyan-700",
  ["teal"]:
    "bg-teal-700 text-white hover:bg-teal-500 focus-visible:outline-teal-700",
  ["emerald"]:
    "bg-emerald-700 text-white hover:bg-emerald-500 focus-visible:outline-emerald-700",
  ["green"]:
    "bg-green-700 text-white hover:bg-green-500 focus-visible:outline-green-700",
  ["lime"]:
    "bg-lime-700 text-white hover:bg-lime-500 focus-visible:outline-lime-700",
  ["yellow"]:
    "bg-yellow-700 text-white hover:bg-yellow-500 focus-visible:outline-yellow-700",
  ["amber"]:
    "bg-amber-700 text-white hover:bg-amber-500 focus-visible:outline-amber-700",
  ["orange"]:
    "bg-orange-700 text-white hover:bg-orange-500 focus-visible:outline-orange-700",
  ["red"]:
    "bg-red-700 text-white hover:bg-red-500 focus-visible:outline-red-700",
  ["stone"]:
    "bg-stone-700 text-white hover:bg-stone-500 focus-visible:outline-stone-700",
  ["neutral"]:
    "bg-neutral-700 text-white hover:bg-neutral-500 focus-visible:outline-neutral-700",
  ["gray"]:
    "bg-gray-700 text-white hover:bg-gray-500 focus-visible:outline-gray-700",
  ["slate"]:
    "bg-slate-700 text-white hover:bg-slate-500 focus-visible:outline-slate-700"
};

const post = async (url, data) => {
  url = `${url}${url.indexOf("?") !== -1 ? "&" : "?"}uuid=${uuidv4()}`;
  return axios({
    method: "post",
    url: url,
    data: data,
    headers: {
      "Content-Type": "application/json"
    }
  });
};

const HorizontalForm = ({
  type,
  handleSubmit,
  submitting,
  cta,
  buttonColorTheme,
  textColorTheme = "none"
}) => (
  <form
    onSubmit={handleSubmit}
    className="flex items-center gap-x-4 p-1 grid grid-cols-1 md:grid-cols-3"
  >
    {(type === "form-email-name" || type === "form-scheduling") && (
      <div className="">
        <label
          htmlFor="name-id"
          className={`block mb-1 text-base ${textColorThemes[textColorTheme]}`}
        >
          Your Name
        </label>

        <Field
          id="name-id"
          tabIndex="2"
          component={TextInputMinimal}
          name="name"
          placeholder="Full Name"
          type="text"
          required={true}
          className={`w-full px-3 py-2 placeholder-gray-300 border ${borderColorThemes[textColorTheme]} rounded-md focus:outline-none focus:ring`}
        />
      </div>
    )}

    <div className="pt-2 md:pt-0">
      <label
        htmlFor="email-id"
        className={`block mb-1 text-base ${textColorThemes[textColorTheme]}`}
      >
        Email Address
      </label>

      <Field
        id="email-id"
        tabIndex="2"
        component={TextInputMinimal}
        name="email"
        placeholder="name@domain.com"
        type="email"
        required={true}
        className={`w-full px-3 py-2 placeholder-gray-300 border ${borderColorThemes[textColorTheme]} rounded-md focus:outline-none focus:ring`}
      />
    </div>

    <div className="">
      <Field component={TextInput} name="id" type="hidden" />
      <div className="mb-1 text-base">{"\u00A0"}</div>
      <input
        disabled={submitting}
        type="submit"
        className={`${buttonColorThemes[buttonColorTheme]} cursor-pointer w-full text-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2`}
        value={cta}
      />
    </div>
  </form>
);

const VerticalForm = ({
  type,
  handleSubmit,
  submitting,
  cta,
  buttonColorTheme,
  textColorTheme
}) => (
  <form onSubmit={handleSubmit} className="p-1">
    {(type === "form-email-name" || type === "form-scheduling") && (
      <div className="mb-6">
        <label
          htmlFor="name-id"
          className={`block mb-1 text-base ${textColorThemes[textColorTheme]}`}
        >
          Your Name
        </label>

        <Field
          id="name-id"
          tabIndex="2"
          component={TextInputMinimal}
          name="name"
          placeholder="Full Name"
          type="text"
          required={true}
          className={`w-full px-3 py-2 placeholder-gray-300 border ${borderColorThemes[textColorTheme]} rounded-md focus:outline-none focus:ring`}
        />
      </div>
    )}

    <div className="mb-6">
      <label
        htmlFor="email-id"
        className={`block mb-1 text-base ${textColorThemes[textColorTheme]}`}
      >
        Email Address
      </label>

      <Field
        id="email-id"
        tabIndex="2"
        component={TextInputMinimal}
        name="email"
        placeholder="name@domain.com"
        type="email"
        required={true}
        className={`w-full px-3 py-2 placeholder-gray-300 border ${borderColorThemes[textColorTheme]} rounded-md focus:outline-none focus:ring`}
      />
    </div>

    <Field component={TextInput} name="id" type="hidden" />

    <div>
      <input
        disabled={submitting}
        type="submit"
        className={`${buttonColorThemes[buttonColorTheme]} cursor-pointer w-full text-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2`}
        value={cta}
      />
    </div>
  </form>
);

const CtaForm = ({ contentSection, slug, url }) => {
  const [dataSaved, setDataSaved] = useState(false);

  const {
    cta_data: {
      cta_primary: ctaPrimary,
      cta_primary_type: ctaPrimaryType,
      cta_secondary: ctaSecondary,
      cta_secondary_type: ctaSecondaryType,
      cta_form_orientation: ctaFormOrientation
    },
    button_color_theme: buttonColorTheme,
    text_color_theme: textColorTheme
  } = contentSection;

  const type = ctaPrimaryType.includes("form")
    ? ctaPrimaryType
    : ctaSecondaryType;

  const cta = ctaPrimaryType.includes("form") ? ctaPrimary : ctaSecondary;

  const onSubmit = async (values) => {
    const {
      data: { status }
    } = await post(`${url}/${slug}/form_api`, values);
    if (status === "ok") setDataSaved(true);
  };

  if (dataSaved)
    return (
      <div
        className={`font-semibold ${textColorThemes[textColorTheme || "none"]}`}
      >
        Thank you!
      </div>
    );

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          html {
            background-color: transparent !important;
          }`
        }}
      ></style>
      <Form
        initialValues={{ id: contentSection.id }}
        onSubmit={onSubmit}
        render={({ handleSubmit, submitting }) =>
          ctaFormOrientation === "horizontal" ? (
            <HorizontalForm
              handleSubmit={handleSubmit}
              submitting={submitting}
              cta={cta}
              type={type}
              buttonColorTheme={buttonColorTheme || "indigo"}
              textColorTheme={textColorTheme || "none"}
            />
          ) : (
            <VerticalForm
              handleSubmit={handleSubmit}
              submitting={submitting}
              cta={cta}
              type={type}
              buttonColorTheme={buttonColorTheme || "indigo"}
              textColorTheme={textColorTheme || "none"}
            />
          )
        }
      />
    </>
  );
};

export default CtaForm;
